const validateIsRequired = (scope, errorText = 'error-required') => {
  const result = !!scope.value
  scope.errors = result ? '' : errorText

  return result
}

const validateDateTime = scope => {
  const result =
    (scope.value.date && scope.value.time) ||
    (scope.value.date === undefined && scope.value.time === undefined) ||
    (scope.value.date === null && scope.value.time.length === 0)
  scope.errors = result ? '' : 'error-both-required'

  return result
}

export { validateIsRequired, validateDateTime }
